(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) Scroll progress bar */
  function bar() {
    var b = document.createElement('div'); b.className = 'scroll-progress';
    var f = document.createElement('span'); b.appendChild(f);
    (document.body || document.documentElement).appendChild(b);
    var update = function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? Math.min(1, window.scrollY / h) : 0;
      f.style.transform = 'scaleX(' + pct.toFixed(4) + ')';
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  /* 2) Staggered card cascade — fail-open: cards stay visible unless JS hides them */
  function stagger() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var groups = [].slice.call(document.querySelectorAll('.dv-carousel, #product-grid, .product-grid'));
    groups.forEach(function (group) {
      var cards = [].slice.call(group.children).filter(function (c) { return c.nodeType === 1; });
      if (cards.length < 2) return;
      if (group.getBoundingClientRect().top < window.innerHeight * 0.9) return; // already visible: leave alone
      cards.forEach(function (c, i) { c.classList.add('stagger-item'); c.style.transitionDelay = (Math.min(i, 10) * 0.04) + 's'; });
      var reveal = function () { cards.forEach(function (c) { c.classList.add('stagger-in'); }); };
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { reveal(); io.disconnect(); } }); }, { threshold: 0.05, rootMargin: '0px 0px -6% 0px' });
      io.observe(group);
      setTimeout(reveal, 2500); // safety
    });
  }

  function init() { bar(); stagger(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
